<div id="gallery">
    <div class="container">
        <div class="row">
            <div class="col-12" data-scroll>
              <h2 class="home-title text-center">
                <span class="second">Life</span> @ <span class="first"> SSJGC</span>
              </h2>
            </div>
          </div>
        <div class="row mt-4">
            <div class="col-12 col-md-3">
                <div class="box" data-scroll>
                    <img [src]="imgUrl[0]" alt="" class="img-fluid type1 mb-3">
                </div>
                <div class="box" data-scroll>
                    <img [src]="imgUrl[3]" alt="" class="img-fluid type2 mb-3">
                </div>
            </div>
            <div class="col-12 col-md-6 mt-5" >
                <div class="box-text mb-3" data-scroll>
                    <h6 class="text-center">The college gallery presents SSJG College’s history, academic achievements, and community through multimedia displays, connecting visitors with the college’s culture and accomplishments.</h6>
                </div>
                <div class="row">
                    <div class="col-6 mb-3" data-scroll>
                        <img [src]="imgUrl[2]" alt="" class="img-fluid type3 mb-3">
                    </div>
                    <div class="col-6 mb-3" data-scroll>
                        <img [src]="imgUrl[6]" alt="" class="img-fluid type3 mb-3">
                    </div>
                </div>
                <div class="row">
                    <div class="col-4 mb-3" data-scroll>
                        <img [src]="imgUrl[5]" alt="" class="img-fluid type3 mb-3">
                    </div>
                    <div class="col-4 mb-3" data-scroll>
                        <img [src]="imgUrl[7]" alt="" class="img-fluid type3 mb-3">
                    </div>
                    <div class="col-4 mb-3" data-scroll>
                        <img [src]="imgUrl[8]" alt="" class="img-fluid type3 mb-3">
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-3">
                <div class="box" data-scroll>
                    <img [src]="imgUrl[4]" alt="" class="img-fluid type2 mb-3">
                </div>
                <div class="box" data-scroll>
                    <img [src]="imgUrl[1]" alt="" class="img-fluid type1 mb-3">
                </div>
            </div>
        </div>
    </div>
</div>